<template>
    <div class="page-container clearfix">
        <div class="left-box">
            <h2>个人中心</h2>
            <ul class="list-box">
                <li
                    :class="['list-item', activeTab === 0 ? 'tab-active' : '']"
                    @click="changeTab(0)"
                    data-type="1"
                >
                    我的课程
                </li>
                <li
                    :class="['list-item', activeTab == 10 ? 'tab-active' : '']"
                    @click="changeTab(10)"
                    data-type="11"
                >
                    线下活动
                </li>
                <li
                    :class="['list-item', activeTab == 1 ? 'tab-active' : '']"
                    @click="changeTab(1)"
                    data-type="2"
                >
                    我的报名
                </li>
                <li
                    :class="['list-item', activeTab == 2 ? 'tab-active' : '']"
                    @click="changeTab(2)"
                    data-type="3"
                >
                    积分订单
                </li>
                <li
                    :class="['list-item', activeTab == 3 ? 'tab-active' : '']"
                    @click="changeTab(3)"
                    data-type="4"
                >
                    我的收藏
                </li>
                <li
                    :class="['list-item', activeTab == 4 ? 'tab-active' : '']"
                    @click="changeTab(4)"
                    data-type="5"
                >
                    修改密码
                </li>
                <li
                    :class="['list-item', activeTab == 5 ? 'tab-active' : '']"
                    @click="changeTab(5)"
                    data-type="6"
                >
                    更换手机号
                </li>
                <li
                    :class="['list-item', activeTab == 6 ? 'tab-active' : '']"
                    @click="changeTab(6)"
                    data-type="7"
                >
                    个人信息
                </li>
                <li
                    :class="['list-item', activeTab == 7 ? 'tab-active' : '']"
                    @click="changeTab(7)"
                    data-type="8"
                >
                    消息通知
                </li>
                <li
                    :class="['list-item', activeTab == 8 ? 'tab-active' : '']"
                    @click="changeTab(8)"
                    data-type="9"
                >
                    积分排行榜
                </li>
                <li
                    :class="['list-item', activeTab == 9 ? 'tab-active' : '']"
                    @click="changeTab(9)"
                    data-type="10"
                >
                    意见反馈
                </li>
            </ul>
        </div>
        <div class="right-box">
            <!-- 我的课程 0 -->
            <div v-show="showList[0]" class="panel-item tab-wdkc">
                <div class="panel-title clearfix">
                    <h3>我的课程</h3>
                </div>
                <div v-if="classData.list.length == 0" class="nothing-box">
                    <p>暂无数据</p>
                </div>
                <table
                    v-show="classData.list.length != 0"
                    class="classes-table myclasses"
                >
                    <thead>
                        <tr>
                            <th>专业名称</th>
                            <th>课程代码</th>
                            <th>课程(班)</th>
                            <th>任课老师</th>
                            <th>上课日期</th>
                            <th>上课时间</th>
                            <th>考试分数</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, index) in classData.list"
                            :key="index"
                        >
                            <td>{{ item.sPName }}</td>
                            <td>{{ item.courseCode }}</td>
                            <td>{{ item.sName }}</td>
                            <td>{{ item.teacherName }}</td>
                            <td>{{ item.courseDate }}</td>
                            <td>{{ item.courseTime }}</td>
                            <td>
                                {{
                                    item.fraction === 0
                                        ? "0"
                                        : item.fraction
                                        ? item.fraction
                                        : "暂未考试"
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagebreak
                    @changePage="getClassData"
                    :current="classData.current"
                    :totalPage="classData.totalPage"
                ></pagebreak>
            </div>
            <!-- 线下活动 10 -->
            <div v-show="showList[10]" class="panel-item tab-wdkc">
                <div class="panel-title clearfix">
                    <h3>线下活动</h3>
                </div>
                <div v-if="xianxiaData.list.length == 0" class="nothing-box">
                    <p>暂无数据</p>
                </div>
                <table
                    v-show="xianxiaData.list.length != 0"
                    class="classes-table unOnline-classes"
                >
                    <thead>
                        <tr>
                            <th>课程名称</th>
                            <th>开课时间</th>
                            <th>开课地点</th>
                            <th>主讲教师</th>
                            <th>剩余名额</th>
                            <th>状态</th>
							<th>备注</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, index) in xianxiaData.list"
                            :key="index"
                        >
                            <td>
                                <u>{{ item.offlineCourseTitle }}</u>
                            </td>
                            <td>{{ item.courseTime }}</td>
                            <td>{{ item.courseAdress }}</td>
                            <td>{{ item.teacherName }}</td>
                            <td>
                                {{ item.surplusNum + "/" + item.peopleNumber }}
                            </td>
                            <td>
                                {{
                         item.registrationStatus == 0 ? "已报名": item.registrationStatus == 1? "已取消报名":item.registrationStatus == 2? "未上课" : "已上课"
                                }}
								<span v-if="item.registrationStatus == 0" class="btnSpan"  @click="cancle(item.id)">取消</span>
                            </td>
							<td>{{item.remarks}}</td>
                        </tr>
                    </tbody>
                </table>
                <pagebreak
                    @changePage="getXianxiaData"
                    :current="xianxiaData.current"
                    :totalPage="xianxiaData.totalPage"
                ></pagebreak>
            </div>
            <!-- 我的报名 1 -->
            <div v-show="showList[1]" class="panel-item tab-wdbm">
                <div class="panel-title clearfix">
                    <h3>我的报名</h3>
                </div>
                <div v-if="baoMingData.list.length == 0" class="nothing-box">
                    <p>暂无数据</p>
                </div>
                <table v-show="baoMingData.list.length != 0" class="my-signup">
                    <thead>
                        <tr>
                            <td>专业名称</td>
                            <td>课程代码</td>
                            <td>课程（班）</td>
                            <td>招生人数</td>
                            <td>上课日期</td>
                            <td>上课时间</td>
                            <td>学习内容</td>
                            <td>报名要求</td>
                            <td>报名时间</td>
                            <td>面试时间</td>
                            <td>面试地点</td>
                            <td>状态</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, index) in baoMingData.list"
                            :key="index"
                        >
                            <td>{{ item.sPName }}</td>
                            <td>{{ item.courseCode }}</td>
                            <td>{{ item.sName }}</td>
                            <td>{{ item.studentNum }}</td>
                            <td>{{ item.courseDate }}</td>
                            <td>{{ item.courseTime }}</td>
                            <td>
                                {{
                                    item.courseContent.length > 140
                                        ? item.courseContent.substring(0, 140) +
                                          "..."
                                        : item.courseContent
                                }}
                            </td>
                            <td>
                                {{
                                    item.requirement.length > 140
                                        ? item.requirement.substring(0, 140) +
                                          "..."
                                        : item.requirement
                                }}
                            </td>
                            <td>{{ item.enterTime }}</td>
                            <td>{{ item.interviewTime }}</td>
                            <td>{{ item.interviewAdress }}</td>
                            <td>
                                {{
                                    item.status == 1
                                        ? "待审核"
                                        : item.status == 2
                                        ? "审核通过"
                                        : "未通过"
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagebreak
                    @changePage="getBaoMingData"
                    :current="baoMingData.current"
                    :totalPage="baoMingData.totalPage"
                ></pagebreak>
            </div>
            <!-- 积分订单 2 -->
            <div v-show="showList[2]" class="panel-item tab-jfdd">
                <div class="panel-title clearfix">
                    <h3>积分订单</h3>
                </div>
                <div v-if="jfddData.list.length == 0" class="nothing-box">
                    <p>暂无数据</p>
                </div>
                <table v-show="jfddData.list.length != 0" class="my-order">
                    <thead>
                        <tr>
                            <th>商品名称</th>
                            <th>兑换积分</th>
                            <th>兑换时间</th>
                            <th>状态</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in jfddData.list" :key="index">
                            <td>
                                <div class="order-list flex-row">
                                    <img :src="item.productImage" alt="" />
                                    <p class="order-title">
                                        {{ item.productname }}
                                    </p>
                                    <p class="order-tips">
                                        <span>参考价</span><br />
                                        <s>￥{{ item.price }}</s>
                                    </p>
                                </div>
                            </td>
                            <td>{{ item.accumulatepoints }}积分</td>
                            <td>
                                {{
                                    item.exchangetime &&
                                        item.exchangetime.time | dateFormat
                                }}
                            </td>
                            <td>
                                <div class="order-msg">
                                    <p>兑换成功</p>
                                    <p>
                                        兑换码：<span>{{
                                            item.exchangecode
                                        }}</span>
                                    </p>
                                    <p v-show="item.status == 0">领取状态：未领取</p>
                                    <p v-show="item.status == 1">领取状态：已领取</p>
                                    <p>
                                        领取日期：<span>{{
                                            item.receivetime &&
                                                item.receivetime.time
                                                    | dateFormat
                                        }}</span>
                                    </p>
                                    <p>
                                        领取地址：<span>{{
                                            item.receiveadress
                                        }}</span>
                                    </p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagebreak
                    @changePage="getOrderData"
                    :current="jfddData.current"
                    :totalPage="jfddData.totalPage"
                ></pagebreak>
            </div>
            <!-- 我的收藏 3 -->
            <div v-show="showList[3]" class="panel-item tab-wdsc">
                <div class="panel-title clearfix">
                    <h3>我的收藏</h3>
                </div>
                <div v-if="cellcetData.list.length == 0" class="nothing-box">
                    <p>暂无数据</p>
                </div>
                <div v-show="cellcetData.list.length != 0" class="collection">
                    <div
                        @click="goZXdetail(item)"
                        v-for="(item, index) in cellcetData.list"
                        :key="index"
                        class="collection-item"
                    >
                        <div class="collection-item-img scale-box">
                            <img :src="item.cover" :alt="item.totalTitle" />
                        </div>
                        <p>
                            {{ item.totalTitle }}
                        </p>
                    </div>
                </div>
                <pagebreak
                    @changePage="getCollectData"
                    :current="cellcetData.current"
                    :totalPage="cellcetData.totalPage"
                ></pagebreak>
            </div>
            <!-- 修改密码 4 -->
            <div v-show="showList[4]" class="panel-item tab-xgmm">
                <div class="panel-title clearfix">
                    <h3>修改密码</h3>
                </div>
                <input
                    class="rset-pwd-text pwd-top"
                    type="password"
                    placeholder="原密码"
                    v-model="oldParsswoed"
                />
                <input
                    class="rset-pwd-text"
                    type="password"
                    placeholder="新密码"
                    v-model="newParsswoed"
                />
                <input
                    class="rset-pwd-text"
                    type="password"
                    placeholder="确认密码"
                    v-model="newParsswoed1"
                />
                <input
                    class="rset-pwd-text rset-pwd-btn"
                    type="button"
                    value="立即提交"
                    @click="changePassword"
                />
            </div>
            <!-- 更换手机号 5 -->
            <div v-show="showList[5]" class="panel-item tab-ghsjh">
                <div class="panel-title clearfix">
                    <h3>更换手机号</h3>
                </div>
                <input
                    class="rset-pwd-text pwd-top"
                    type="text"
                    placeholder="原手机号"
                    v-model="phoneData.oldPhone"
                    maxlength="11"
                />
                <input
                    class="rset-pwd-text"
                    type="password"
                    placeholder="密码"
                    v-model="phoneData.password"
                    maxlength="11"
                />
                <input
                    class="rset-pwd-text"
                    type="text"
                    placeholder="身份证号"
                    v-model="phoneData.idCard"
                    maxlength="18"
                />
                <input
                    class="rset-pwd-text"
                    type="text"
                    placeholder="新手机号"
                    v-model="phoneData.newPhone"
                    maxlength="11"
                />
                <input
                    class="rset-pwd-text rset-pwd-btn"
                    type="button"
                    value="提交"
                    @click="changePhone"
                />
            </div>
            <!-- 个人信息 6 -->
            <div v-show="showList[6]" class="panel-item tab-grxx">
                <div class="panel-title clearfix">
                    <h3>个人信息</h3>
                </div>
                <table class="person-msg">
                    <tbody>
                        <tr>
                            <td>头像:</td>
                            <td>
                                <div class="upload-avatar flex-row">
                                    <div class="prev-avatar">
                                        <img
                                            :src="
                                                personData.avatar
                                                    ? personData.avatar
                                                    : 'static/img/head.png'
                                            "
                                            alt=""
                                        />
                                    </div>
                                    <label for="avatar">
                                        <div class="avatar-label flex-row">
                                            <span>更改头像</span>
                                        </div>
                                        <input
                                            style="display:none"
                                            type="file"
                                            id="avatar"
                                            accept="image/*"
                                            @change="prevAvatar($event)"
                                        />
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>*用户名:</td>
                            <td>
                                <input
                                    class="person-msg-input"
                                    v-model="personData.nickname"
                                    type="text"
                                    maxlength="16"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>姓名:</td>
                            <td>
                                <p class="person-msg-input cannot-change">
                                    {{ personData.name }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>性别:</td>
                            <td>
                                <p class="person-msg-input cannot-change">
                                    {{ personData.sex }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>身份证号:</td>
                            <td>
                                <p class="person-msg-input cannot-change">
                                    {{ personData.idcard.substr(0,3)+"******"+personData.idcard.substr(14,17) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>手机号:</td>
                            <td>
                                <p class="person-msg-input cannot-change">
                                    {{ personData.phone.substr(0,3)+"***"+personData.phone.substr(7,11) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>民族:</td>
                            <td>
                                <input
                                    v-model="personData.nationality"
                                    class="person-msg-input"
                                    type="text"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>现住址:</td>
                            <td>
                                <textarea
                                    name="hobbies"
                                    v-model="personData.address"
                                    rows="3"
                                ></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>电子邮箱:</td>
                            <td>
                                <input
                                    class="person-msg-input"
                                    v-model="personData.email"
                                    type="text"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>个人爱好:</td>
                            <td>
                                <textarea
                                    name="hobbies"
                                    v-model="personData.hobby"
                                    rows="5"
                                ></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <input
                                    @click="updatePersonData"
                                    class="submit-pserson-msg"
                                    type="button"
                                    value="立即提交"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 消息通知 7 -->
            <div v-show="showList[7]" class="panel-item tab-xxtz">
                <div class="serv-msg-title clearfix">
                    <p
                        @click="changeTipsActive(1)"
                        :class="tipsActive == 1 ? 'active' : ''"
                    >
                        站内通知
                    </p>
                    <p
                        @click="changeTipsActive(2)"
                        :class="tipsActive == 2 ? 'active' : ''"
                    >
                        公告通知
                    </p>
                </div>
                <ul v-show="tipsActive == 1" class="serv-msg-box">
                    <li
                        v-for="(item, index) in tipsZhanNeiData"
                        :key="index"
                        class="serv-msg-item"
                        @click="showMessage(item)"
                    >
                        <a class="clearfix" href="javascript:;"
                            >{{ item.title
                            }}<span>{{
                                item.createTime.time | dateFormat
                            }}</span></a
                        >
                    </li>
                </ul>
                <ul v-show="tipsActive == 2" class="serv-msg-box">
                    <li
                        v-for="(item, index) in tipsGongGaoData"
                        :key="index"
                        class="serv-msg-item"
                        @click="showMessage(item)"
                    >
                        <a class="clearfix" href="javascript:;"
                            >{{ item.title
                            }}<span>{{
                                item.createTime.time | dateFormat
                            }}</span></a
                        >
                    </li>
                </ul>
                <pagebreak
                    :current="tipsPageData.current"
                    @changePage="changeTipsPage"
                    :totalPage="tipsPageData.totalPage"
                ></pagebreak>
            </div>
            <!-- 积分排行 8 -->
            <div v-show="showList[8]" class="panel-item tab-jfphb">
                <div class="panel-title clearfix">
                    <h3>积分排行榜</h3>
                    <p>
                        <span class="title-right"
                            >我的排行：{{ selfJfData===null?'暂无':selfJfData.rownum }}</span
                        >
                        <span class="title-right"
                            >年度积分：<span class="number-count">{{
                            selfJfData===null?0:selfJfData.credit
                            }}</span></span
                        >
                        <span class="title-right"
                            >总积分：<span class="number-count">{{
                            selfJfData===null?0:selfJfData.totalCredit
                            }}</span></span
                        >
                        <span class="title-right"
                            >已兑换：<span class="number-count">{{
                            selfJfData===null?0:selfJfData.usedcredit
                            }}</span></span
                        >
                    </p>
                </div>
                <table class="jf-body">
                    <thead>
                        <tr>
                            <th width="90">排名</th>
                            <th width="120">姓名</th>
                            <th width="120">年度积分</th>
                            <th>已兑换</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in JfphData" :key="index">
                            <td>
                                <img
                                    v-if="
                                        (index == 0) |
                                            (index == 1) |
                                            (index == 2)
                                    "
                                    :src="
                                        index === 0
                                            ? 'static/img/3.png'
                                            : index == 1
                                            ? 'static/img/2.png'
                                            : index == 2
                                            ? 'static/img/5.png'
                                            : ''
                                    "
                                />
                                <span
                                    v-if="
                                        index != 0 && index != 1 && index != 2
                                    "
                                    >{{ index + 1 }}</span
                                >
                            </td>
                            <td>{{ item.NICKNAME }}</td>
                            <td>{{ item.CREDIT }}</td>
                            <td>{{ item.USEDCREDIT ? item.USEDCREDIT : 0 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 意见反馈 9 -->
            <div v-show="showList[9]" class="panel-item tab-yjfk">
                <div class="panel-title clearfix">
                    <h3>意见反馈</h3>
                </div>
                <table class="feedback-box">
                    <tbody>
                        <tr>
                            <td width="25%"></td>
                            <td width="75%">
                                您对密云教学网有任何意见和建议，或在使用过程中遇到问题，请在本页面反馈。我们会每天关注您的反馈，不断优化产品，为您提供更好的服务！
                            </td>
                        </tr>
                        <tr>
                            <td>反馈类型：</td>
                            <td>
                                <label for="jxfk">
                                    <input
                                        type="radio"
                                        name="feedback-type"
                                        v-model="feedBackData.type"
                                        value="1"
                                        id="jxfk"
                                    />教学反馈
                                </label>
                                <label for="syyjjy">
                                    <input
                                        type="radio"
                                        v-model="feedBackData.type"
                                        name="feedback-type"
                                        value="2"
                                        id="syyjjy"
                                    />首页意见建议
                                </label>
                                <label for="fwts">
                                    <input
                                        type="radio"
                                        v-model="feedBackData.type"
                                        name="feedback-type"
                                        id="fwts"
                                        value="3"
                                    />服务投诉
                                </label>
                                <label for="fwby">
                                    <input
                                        type="radio"
                                        v-model="feedBackData.type"
                                        name="feedback-type"
                                        value="4"
                                        id="fwby"
                                    />服务表扬
                                </label>
                                <label for="wtbg">
                                    <input
                                        type="radio"
                                        v-model="feedBackData.type"
                                        name="feedback-type"
                                        id="wtbg"
                                        value="5"
                                    />问题报告
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>手机/邮箱：</td>
                            <td>
                                <input
                                    v-model="feedBackData.phoneEmail"
                                    class="phone-email"
                                    type="text"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>内容：</td>
                            <td>
                                <textarea
                                    v-model="feedBackData.content"
                                    placeholder="请尽量填写10-1000字，以便我们及时给您回复。"
                                    name=""
                                    rows="10"
                                    maxlength="1000"
                                ></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <input
                                    @click="submitYijian"
                                    class="submit-pserson-msg"
                                    type="button"
                                    value="立即提交"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
       <transition
            enter-active-class="fadeInDown"
            leave-active-class="fadeOutUp"
        >
            <div v-show="showDilog" class="dilog-person flex-row animated">
                <p
                    v-if="errorTag != 3"
                    :class="[
                        errorTag == 1 ? 'err-icon' : 'success-icon',
                        'iconfont'
                    ]"
                    v-html="errorTag == 1 ? '&#xe66f;' : '&#xe605;'"
                ></p>
                <p class="err-text">{{ showDilogText }}</p>
            </div>
        </transition>
        <div v-if="showMessageTag" class="message-client-box">
            <div class="message-content-box">
                <div
                    @click="showMessageTag = false"
                    class="message-close flex-row iconfont"
                >
                    &#xe66f;
                </div>
                <div class="message-detail-box">
                    <div class="message-title">
                        {{ showMessageData.title }}
                    </div>
                    <div class="message-time">
                        {{ showMessageData.createTime.time | dateFormat }}
                    </div>
                    <div class="message-content">
                        {{ showMessageData.content }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import md5 from "js-md5";
import { mapState, mapMutations } from "vuex";
import { testPhone, testEmail, testIDcard, testPassword} from "@/common/util";
import { encrypt } from "@/common/aes";
export default {
    data() {
        return {
            showList: [
                true,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            activeTab: 0,
            showDilog: false,
            errorTag: 1, //1 err  2 success 3 none
            showDilogText: "",
            // 设置定时器
            timmer: null,
            // 消息通知
            tipsActive: 1,
            tipsCancel: null,
            tipsPageData: {
                totalPage: 1,
                current: 1
            },
            tipsZhanNeiData: [],
            tipsGongGaoData: [],
            showMessageTag: false,
            showMessageData: {},
            // 修改密码数据
            oldParsswoed: "",
            newParsswoed: "",
            newParsswoed1: "",
            // 更换手机号数据
            phoneData: {
                oldPhone: "",
                idCard: "",
                newPhone: "",
                password: "",
                pending: false
            },
            // 个人信息
            personData: {
                avatar: "",
                nickname: "",
                phone: "",
                sex: "",
                idcard: "",
                email: "",
                hobby: "",
                address: "",
                nationality: "",
                name: "",
                file: "",
                pending: false
            },
            // 积分排行榜数据
            selfJfData: {},
            JfphData: [],
            // 意见反馈
            feedBackData: {
                type: 0,
                phoneEmail: "",
                content: "",
                pending: false
            },
            // 我得报名
            baoMingData: {
                totalPage: 0,
                current: 1,
                list: []
            },
            // 我得课程
            classData: {
                totalPage: 0,
                current: 1,
                list: []
            },
            // 线下活动
            xianxiaData: {
                totalPage: 0,
                current: 1,
                list: []
            },
            // 积分订单
            jfddData: {
                totalPage: 0,
                current: 1,
                list: []
            },
            // 我得收藏
            cellcetData: {
                totalPage: 0,
                current: 1,
                list: []
            }
        };
    },
    created() {
        if (!this.$store.state.hasLogin) {
            this.$router.push({
                name: "login"
            });
        }
        if (this.$route.query.type) {
            this.changeTab(parseInt(this.$route.query.type));
        } else {
            this.changeTab(0);
        }
    },
    methods: {
		// 取消报名
		cancle(id){
			// cancelOfflineActivitiesStudy
			this.$ajax({
			    url: "homePage/cancelOfflineActivitiesStudy",
			    method: "post",
			    data: {
			        token: this.$store.state.userToken,
			        id:id
			    },
			    success: res => {
			        if (res.code == 200) {
						this.showDilogBox(2, "已成功取消");
						// 刷新数据
						this.getXianxiaData();
			        }else{
						this.showDilogBox(1, "取消失败");
					}
			    },
			    error: res => {}
			});
		},
        changeTab(index) {
            this.showList = [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ];
            this.activeTab = index;
            this.showList[index] = true;
            switch (index) {
                case 0:
                    // 我的课程
                    this.getClassData();
                    break;
                case 1:
                    this.getBaoMingData(1);
                    // 我的报名
                    break;
                case 2:
                    this.getOrderData();
                    // 积分订单
                    break;
                case 3:
                    this.getCollectData();
                    // 我的收藏
                    break;
                case 4:
                    // 修改密码
                    break;
                case 5:
                    // 更换手机号
                    break;
                case 6:
                    this.getPersonData();
                    // 个人信息
                    break;
                case 7:
                    this.changeTipsActive(2);
                    // 消息通知
                    break;
                case 8:
                    // 积分排行榜
                    this.getJfphData();
                    break;
                case 9:
                    // 意见反馈
                    break;
                case 10:
                    this.getXianxiaData();
                    // 线下课程
                    break;
                default:
                    break;
            }
        },
        // 我的课程
        getClassData(page = 1) {
            this.$ajax({
                url: "userApi/myCommunityUniversitySu",
                method: "post",
                data: {
                    token: this.$store.state.userToken,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        this.classData.list = res.message.records;
                        this.classData.current = page;
                        this.classData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                },
                error: res => {}
            });
        },
        goZXdetail(item) {
            if (this.$store.state.hasLogin) {
                this.$router.push({
                    name: "zxstudy",
                    query: {
                        id: item.id
                    }
                });
            } else {
                this.$router.push({
                    name: "login"
                });
            }
        },
        // 线下课程
        getXianxiaData(page = 1) {
            // userApi/myOfflineActivities
            this.$ajax({
                url: "userApi/myOfflineActivities",
                method: "post",
                data: {
                    token: this.$store.state.userToken,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        this.xianxiaData.list = res.message.records;
                        this.xianxiaData.current = page;
                        this.xianxiaData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                },
                error: res => {}
            });
        },
        // 我的报名
        getBaoMingData(page = 1) {
            this.$ajax({
                url: "userApi/myCommunityUniversity",
                method: "post",
                data: {
                    token: this.$store.state.userToken,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        this.baoMingData.list = res.message.records;
                        this.baoMingData.current = page;
                        this.baoMingData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                },
                error: res => {}
            });
        },
        // 积分订单
        getOrderData(page = 1) {
            // userApi/exchangeList
            this.$ajax({
                url: "userApi/exchangeList",
                method: "post",
                data: {
                    token: this.$store.state.userToken,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        this.jfddData.list = res.message.records;
                        this.jfddData.current = page;
                        this.jfddData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                },
                error: res => {}
            });
        },
        // 我的收藏
        getCollectData(page = 1) {
            // userApi/myCollectionCourses
            this.$ajax({
                url: "userApi/myCollectionCourses",
                method: "post",
                data: {
                    token: this.$store.state.userToken,
                    current: page
                },
                success: res => {
                    console.log("我的收藏");
                    console.log(res);
                    if (res.code == 200) {
                        this.cellcetData.list = res.message.records;
                        this.cellcetData.current = page;
                        this.cellcetData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                },
                error: res => {}
            });
        },
        // 消息提示框
        showDilogBox(type, text) {
            this.showDilog = false;
            this.showDilogText = text;
            this.errorTag = type;
            this.showDilog = true;
            if (this.timmer) {
                clearTimeout(this.timmer);
                this.timmer = null;
            }
            this.timmer = setTimeout(() => {
                this.showDilog = false;
                clearTimeout(this.timmer);
                this.timmer = null;
            }, 2000);
        },
        // 修改密码
        changePassword() {
            if (this.phoneData.pending) {
                this.showDilogBox(3, "正在提交");
                return;
            }
            if (this.oldParsswoed.length < 6 || this.oldParsswoed.length > 16) {
                this.showDilogBox(1, "密码长度应为6~16位");
                return;
            }
            if (!testPassword(this.password)) {
                this.showDilogBox(1, "请输入10~18位字母、数字、特殊字符组合");
                return;
            }
            if (this.newParsswoed != this.newParsswoed1) {
                this.showDilogBox(1, "两次密码不同");
                return;
            }
            this.phoneData.pending = true;

            if (this.$store.state.userToken) {
                this.$ajax({
                    method: "post",
                    url: "userApi/changePassword",
                    data: {
                        token: this.$store.state.userToken,
                        oldPassword: encrypt(md5(this.oldParsswoed)),
                        newPassword: encrypt(md5(this.newParsswoed))
                    },
                    success: res => {
                        if (res.code == 200) {
                            this.showDilogBox(2, "修改密码成功");
                            this.oldParsswoed = "";
                            this.newParsswoed = "";
                            this.newParsswoed1 = "";
                        } else {
                            this.showDilogBox(1, res.message);
                        }
                        this.phoneData.pending = false;
                    },
                    error: () => {
                        this.phoneData.pending = false;
                    }
                });
            }
        },
        // 修改手机号
        changePhone() {
            if (this.phoneData.pending) {
                this.showDilogBox(3, "正在提交");
                return;
            }
            if (!testPhone(this.phoneData.oldPhone)) {
                this.showDilogBox(1, "原手机号格式错误");
                return;
            }
            if (
                this.phoneData.password.length < 6 ||
                this.phoneData.password.length > 19
            ) {
                this.showDilogBox(1, "密码格式错误，为6~18位字符");
                return;
            }
            if (!testIDcard(this.phoneData.idCard)) {
                this.showDilogBox(1, "身份证格式错误");
                return;
            }
            if (!testPhone(this.phoneData.newPhone)) {
                this.showDilogBox(1, "新手机号格式错误");
                return;
            }
            this.phoneData.pending = true;

            if (this.$store.state.userToken) {
                this.$ajax({
                    method: "post",
                    url: "userApi/changePhone",
                    data: {
                        token: this.$store.state.userToken,
                        password: encrypt(md5(this.phoneData.password)),
                        oldPhone: encrypt(this.phoneData.oldPhone),
                        idCard: encrypt(this.phoneData.idCard),
                        newPhone: encrypt(this.phoneData.newPhone)
                    },
                    success: res => {
                        if (res.code == 200) {
                            this.showDilogBox(2, "修改手机号成功");
                            this.phoneData.password = "";
                            this.phoneData.oldPhone = "";
                            this.phoneData.idCard = "";
                            this.phoneData.newPhone = "";
                        } else {
                            this.showDilogBox(1, res.message);
                        }
                        this.phoneData.pending = false;
                    },
                    error: () => {
                        this.phoneData.pending = false;
                    }
                });
            }
        },
        // 头像预览
        prevAvatar(event) {
            this.personData.file = "";
            var reader = new FileReader();

            reader.onload = res => {
                this.personData.avatar = res.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);

            this.personData.file = event.target.files[0];
        },
        // 获取个人信息
        getPersonData() {
            this.$ajax({
                method: "post",
                url: "userApi/lookUser",
                data: {
                    token: this.$store.state.userToken
                },
                success: res => {
                    if (res.code == 200) {
                        this.personData = {
                            avatar: res.message.avatar,
                            nickname: res.message.nickname,
                            phone: res.message.phone,
                            sex: res.message.sex == "M" ? "男" : "女",
                            idcard: res.message.idcard,
                            email: res.message.email,
                            hobby: res.message.hobby,
                            address: res.message.address,
                            nationality: res.message.nationality,
                            name: res.message.name,
                            pending: false
                        };

                        this.$store.commit("setAvatar", res.message.avatar);
                    }
                }
            });
        },
        // 提交个人信息
        updatePersonData() {
            if (this.personData.pending) {
                this.showDilogBox(3, "正在提交");
                return;
            }
            var formData = new window.FormData();

            if (!this.$store.state.userToken) {
                return;
            }
            formData.append("token", this.$store.state.userToken);
            if (this.personData.file) {
                formData.append("pic", this.personData.file);
            }
            if (
                this.personData.nickname.length < 2 ||
                this.personData.nickname.length > 16
            ) {
                this.showDilogBox(1, "用户名长度为2~16位字符");
                return;
            }
            formData.append("nickname", this.personData.nickname);

            if (this.personData.nationality) {
                formData.append("nationality", this.personData.nationality);
            }
            if (this.personData.address) {
                formData.append("address", this.personData.address);
            }
            if (this.personData.email) {
                formData.append("email", this.personData.email);
            }
            if (this.personData.hobby) {
                formData.append("hobby", this.personData.hobby);
            }
            this.personData.pending = true;
            this.$ajax({
                url: "userApi/updateUser",
                data: formData,
                cache: false,
                processData: false,
                contentType: false,
                success: res => {
                    if (res.code == 200) {
                        this.showDilogBox(2, "修改成功");
                    } else {
                        this.showDilogBox(1, res.message);
                    }
                    this.personData.pending = false;
                },
                error: () => {
                    this.personData.pending = false;
                }
            });
        },
        // 改变消息通知
        changeTipsActive(type) {
            this.tipsActive = type;
            if (this.tipsCancel) {
                this.tipsCancel();
                this.tipsCancel = null;
            }
            if (type == 1) {
                this.getTipsData(type, 1);
            } else {
                this.getTipsData(type, 1);
            }
        },
        changeTipsPage(index) {
            getTipsData(this.tipsActive, index);
        },
        getTipsData(type, page = 1) {
            this.$ajax(
                {
                    method: "post",
                    url: type == 1 ? "userApi/myNotice" : "userApi/notice",
                    data: {
                        current: page,
                        token: this.$store.state.userToken
                    },
                    success: res => {
                        if (res.code == 200) {
                            if (type == 1) {
                                this.tipsPageData.current = page;
                                this.tipsPageData.totalPage = Math.ceil(
                                    res.message.total / res.message.size
                                );
                                this.tipsZhanNeiData = res.message.records;
                                console.log(res);
                            } else {
                                this.tipsPageData.current = page;
                                this.tipsPageData.totalPage = Math.ceil(
                                    res.message.total / res.message.size
                                );
                                this.tipsGongGaoData = res.message.records;
                                console.log(res);
                            }
                        }
                    },
                    error: () => {}
                },
                this.tipsCancel
            );
        },
        showMessage(item) {
            this.showMessageData = item;
            this.showMessageTag = true;
        },
        // 积分排行榜
        getJfphData() {
            this.$ajax({
                url: "userApi/creditList",
                method: "post",
                data: {
                    token: this.$store.state.userToken
                },
                success: res => {
                    if (res.code == 200) {
                        this.selfJfData = res.credit;
                        this.JfphData = res.list.records;
                    }
                },
                error: () => {}
            });
        },
        // 意见反馈
        submitYijian() {
            if (this.feedBackData.pending) {
                this.showDilogBox(3, "正在提交");
                return;
            }
            if (this.feedBackData.type == 0) {
                this.showDilogBox(1, "请选择类别");
                return;
            }

            console.log(testPhone(this.feedBackData.phoneEmail));
            console.log(testEmail(this.feedBackData.phoneEmail));

            if (
                !testPhone(this.feedBackData.phoneEmail) &&
                !testEmail(this.feedBackData.phoneEmail)
            ) {
                this.showDilogBox(1, "手机号或邮箱格式错误");
                return;
            }
            if (this.feedBackData.content.length < 10) {
                this.showDilogBox(1, "多提交点意见吧");
                return;
            }
            this.feedBackData.pending = true;
            this.$ajax({
                url: "userApi/feedback",
                method: "post",
                data: {
                    token: this.$store.state.userToken,
                    type: this.feedBackData.type,
                    phoneOrEmail: this.feedBackData.phoneEmail,
                    content: this.feedBackData.content
                },
                success: res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.feedBackData.phoneEmail = "";
                        this.feedBackData.content = "";
                        this.feedBackData.type = "";

                        this.showDilogBox(2, "提交成功");
                    } else {
                        this.showDilogBox(1, "提交失败");
                    }
                    this.feedBackData.pending = false;
                },
                error: () => {
                    this.feedBackData.pending = false;
                }
            });
        }
    },
    watch: {
        "$store.state.hasLogin": function(nval) {
            if (!nval) {
                this.$router.push({
                    name: "login"
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.dilog-person {
    position: fixed;
    width: 300px;
    min-height: 80px;
    border-radius: 4px;
    border: 1px solid #ddd;
    box-shadow: 0 0 10px #000;
    background-color: #fff;
    top: 350px;
    right: 50%;
    margin-right: -150px;
    .err-icon {
        line-height: 40px;
        height: 40px;
        width: 50px;
        text-align: center;
        font-size: 28px;
        color: red;
    }
    .success-icon {
        line-height: 40px;
        height: 40px;
        width: 50px;
        text-align: center;
        font-size: 28px;
        color: green;
    }
    .err-text {
        font-size: 16px;
        flex: 1;
        padding-left: 20px;
    }
}
.page-container {
    padding-top: 25px;
    width: 1000px;
    min-height: 650px;
    margin: 0 auto;
    font-size: 16px;
    color: #000;
    margin-bottom: 30px;
}

.left-box {
    width: 165px;
    border-width: 1px;
    border-style: solid;
    border-color: #eee;
    text-align: left;
    overflow: hidden;
    float: left;
}

.left-box h2 {
    font-size: 18px;
    color: #000;
    height: 30px;
    line-height: 30px;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: #dfdfdf;
    text-indent: 20px;
    padding: 10px 0;
    font-size: 16px;
}

.list-box li {
    text-indent: 20px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
}

.list-box li:hover {
    color: #666;
    cursor: pointer;
}

/* 右侧盒子 */
.right-box {
    width: 800px;
    float: right;
    padding-top: 12px;
}

.panel-item {
    width: 100%;
    overflow: hidden;
}

.panel-title {
    width: 100%;
    height: 38px;
    line-height: 38px;
    position: relative;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: #ddd;
}

.panel-title::before {
    content: "";
    width: 70px;
    height: 2px;
    background-color: #8fceed;
    position: absolute;
    bottom: -2px;
    left: 0;
}

.panel-title h3 {
    display: inline-block;
    font-size: 18px;
    font-weight: bold;
    color: #595959;
}

/* 积分排行 */
.panel-title p {
    float: right;
    display: inline-block;
}

.panel-title p .title-right {
    margin-left: 20px;
}

.panel-title p .number-count {
    color: #8fceed;
}

.jf-body {
    margin-top: 20px;
}

.jf-body thead tr {
    height: 50px;
    line-height: 50px;
}

.jf-body tr {
    height: 30px;
    line-height: 30px;
}

.jf-body tr td:nth-child(1) span {
    display: inline-block;
    min-width: 15px;
    text-align: center;
}

/* 修改密码 */
.rset-pwd-text {
    display: block;
    width: 253px;
    height: 34px;
    background-color: #ffffff;
    border: solid 1px #84b0f6;
    margin: 0 auto;
    margin-top: 18px;
    text-indent: 10px;
}

.pwd-top {
    margin-top: 40px;
}

.rset-pwd-btn {
    background-color: #009cff;
    border-radius: 4px;
    color: #fff;
    text-indent: 0;
}

/* 我的课程 */
.classes-table {
    margin-top: 20px;
    border-width: 1px;
    border-style: solid;
    border-color: #999;
    font-size: 14px;
    width: 100%;
}

.classes-table thead tr {
    border-bottom: 1px solid #999;
    height: 45px;
}

.classes-table th {
    padding: 0 5px;
    font-size: 14px;
    text-align: center;
}

.classes-table tr {
    padding: 0 5px;
    font-size: 14px;
    height: 30px;
}

.classes-table td {
    padding: 0 5px;
    font-size: 14px;
    text-align: center;
}

.unOnline-title {
    margin-top: 50px;
}

/* 我的收藏 */

.collection-item {
    display: inline-block;
    width: 192px;
    margin-top: 20px;
    margin-right: 4px;
}

.collection-item img {
    width: 100%;
    min-height: 100%;
    vertical-align: middle;
}

.collection-item-img {
    height: 130px;
    width: 192px;
    border: 1px solid #ddd;
}

.collection-item p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

/* 我的报名 */
.my-signup {
    width: 100%;
    font-size: 14px;
    text-align: center;
    margin-top: 20px;
}

.my-signup td {
    border: 1px solid #999;
    padding: 2px;
}

/* 积分订单 */
.my-order {
    margin-top: 20px;
    width: 100%;
    font-size: 14px;
}

.my-order tr,
.my-order th {
    padding: 20px 0;
    border: 1px solid #999;
}

.my-order th {
    text-align: center;
    padding: 20px 0;
    border: 1px solid #999;
}
.my-order th:nth-child(1) {
    width: 320px;
}
.order-list {
    width: 300px;
    padding: 0;
    align-items: center;
    flex-wrap: nowrap;
    padding-left: 15px;
}
.order-list img {
    width: 60px;
    height: 60px;
    display: inline-block;
    vertical-align: middle;
}

.order-list .order-title {
    display: inline-block;
    width: 180px;
    padding: 0 10px;
    vertical-align: middle;
    overflow: hidden;
}

.order-list .order-tips {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
}

.order-msg {
    text-align: left;
    width: 220px;
    word-break: break-all;
}

/* 个人信息 */
.person-msg {
    margin: 0 auto;
    margin-top: 20px;
}

.person-msg tr {
    height: 30px;
}

.person-msg td {
    padding-top: 20px;
}

.person-msg tr td:nth-child(1) {
    text-align: right;
    vertical-align: top;
}

.person-msg tr td:nth-child(2) {
    padding-left: 10px;
}

.person-msg-input {
    width: 300px;
    height: 26px;
    border: 1px solid #999;
}

.cannot-change {
    border: 0;
    color: #333;
}

.person-msg label {
    display: inline-block;
    width: 50px;
}

.person-msg textarea {
    width: 300px;
    display: inline-block;
}

.upload-avatar {
    height: 80px;
    position: relative;
    label {
        display: block;
        width: 82px;
        height: 82px;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition: all ease 0.3s;
        z-index: 1;
    }
    label:hover {
        opacity: 0.8;
    }
    .avatar-label {
        height: 80px;
        width: 80px;
        justify-content: space-around;
        background-color: #fff;
        border: 1px solid #ddd;
        span {
            font-size: 16px;
            line-height: 20px;
            font-weight: bold;
        }
    }
    .prev-avatar {
        width: 80px;
        height: 80px;
        background-color: #fff;
        border: 1px solid #ddd;
        img {
            width: 100%;
            height: 100%;
        }
    }
}

.submit-pserson-msg {
    background-color: #009cff;
    border-radius: 4px;
    color: #fff;
    text-indent: 0;
    display: block;
    width: 253px;
    height: 34px;
    border: solid 1px #84b0f6;
    text-indent: 10px;
}

/* 通知公告 */
.serv-msg-title {
    padding: 0;
    margin: 0;
}

.serv-msg-title p {
    width: 160px;
    height: 40px;
    border: 1px solid #999;
    vertical-align: middle;
    line-height: 40px;
    text-align: center;
    float: left;
    cursor: pointer;
    transition: all ease 0.2s;
}

.serv-msg-title p:nth-child(1) {
    border-right: 0;
}

.serv-msg-title .active {
    background-color: #999;
}

.serv-msg-box {
    width: 100%;
    margin-top: 20px;
    min-height: 400px;
}

.serv-msg-item {
    line-height: 40px;
    height: 40px;
}

.serv-msg-item a {
    display: block;
    width: 600px;
    color: #666;
}

.serv-msg-item a:hover {
    color: #000;
}

.serv-msg-item span {
    float: right;
}

/* 意见反馈 */
.feedback-box {
    margin-top: 20px;
    width: 100%;
}

.feedback-box tr td:nth-child(1) {
    text-align: right;
    vertical-align: top;
}

.feedback-box tr td:nth-child(2) {
    padding-left: 10px;
}

.feedback-box tbody td {
    padding: 10px;
}

.feedback-box .phone-email {
    border: 1px solid #999;
    width: 400px;
    height: 30px;
    line-height: 30px;
}

.feedback-box textarea {
    width: 400px;
}

.tab-active {
    font-weight: bold;
}
.tab-active:hover {
    color: #000 !important;
}
.nothing-box {
    display: flex;
    height: 300px;
    align-items: center;
    p {
        flex: 1;
        text-align: center;
    }
}
.message-client-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 999;
    .message-content-box {
        padding: 20px;
        width: 500px;
        position: absolute;
        top: 200px;
        left: 50%;
        margin-left: -260px;
        z-index: 10;
        border-radius: 4px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        background-color: #fff;
        padding-top: 35px;
        .message-close {
            font-size: 25px;
            width: 25px;
            height: 25px;
            line-height: 25px;
            position: absolute;
            top: 0;
            right: 0;
            margin: 5px;
            color: #999;
            cursor: pointer;
            transition: all ease 0.3s;
        }
        .message-close:hover {
            color: #000;
        }
        .message-detail-box {
            max-height: 450px;
            overflow-y: scroll;
            .message-title {
                font-size: 18px;
                font-weight: bold;
            }
            .message-time {
                font-size: 14px;
                padding: 5px 0;
                color: #999;
            }
            .message-content {
                font-size: 16px;
                word-break: break-all;
            }
        }
    }
}
.btnSpan{
	color: white;
	background-color: #009cff;
	padding:1px 5px;
	border-radius: 3px;
	display: inline-block;
	font-size: 12px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/grzx/personal.vue